import {times} from 'lodash-es';

const ANIMATION_FLASH_CLASS_COUNT = 2; // Should be less or equal to the related value in the styles.
const ANIMATION_FLASH_CLASSES = times(ANIMATION_FLASH_CLASS_COUNT, index => `-flash-${index}`);

export interface FlashAnimationValue {
    state: number;
    className: string;
}

export const updateFlashAnimationValue = (value: FlashAnimationValue, isFlash: boolean, addCls?: string): FlashAnimationValue => {
    if (isFlash) {
        value.state = value.state % ANIMATION_FLASH_CLASS_COUNT + 1;
    } else {
        value.state = 0;
    }

    if (value.state) {
        const flashCls = ANIMATION_FLASH_CLASSES[value.state - 1];

        value.className = addCls ? `${flashCls} ${addCls}` : flashCls;
    } else {
        value.className = '';
    }

    return value;
};

export const createFlashAnimationValue = (): FlashAnimationValue => ({
    state: 0,
    className: ''
});
